import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { clientActions, clientSelectors } from "../../../ducks/client";
import { groupActions } from "../../../ducks/group";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const useGroupRegistration = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();

  const clients = useSelector(clientSelectors.clients);

  useEffect(() => {
    dispatch(appActions.showLoading());

    dispatch(
      clientActions.fetchClients.started({
        sort_key: "id",
        sort_order: "asc",
        onComplete: () => dispatch(appActions.hideLoading()),
      }),
    );
  }, []);

  const handleCancel = useCallback(() => {
    dispatch(
      appActions.showModal({
        title: "内容は保存されません。よろしいですか？",
        buttons: [
          {
            variant: "dark",
            text: "閉じる",
            onClick: () => {
              dispatch(appActions.hideModal());
            },
          },
          {
            variant: "filled",
            text: "保存しない",
            onClick: () => {
              dispatch(appActions.hideModal());
              navigateToPage(PageRoutes.GROUPS);
            },
          },
        ],
      }),
    );
  }, []);

  const handleRegisterGroup = useCallback(
    (customerId: string, name: string) => {
      dispatch(appActions.showLoading());

      dispatch(
        groupActions.registerNewGroup.started({
          customer_id: customerId,
          name,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: () => {
            dispatch(
              appActions.showNotification({
                message: "グループを登録しました",
                type: "success",
              }),
            );
            navigateToPage(PageRoutes.GROUPS);
          },
        }),
      );
    },
    [],
  );

  return { clients, handleCancel, handleRegisterGroup };
};
